@use "../common.scss" as *;

:host {
  display: block;
  block-size: 100%;
  overflow: auto;
}

.main {
  overflow: auto;
  display: block;
}

.input-filter {
  inline-size: 33%;
  min-inline-size: 300px;
}

ch-accordion-render {
  inline-size: 100%;
  block-size: 100%;
}

.accordion-content {
  inline-size: 100%;
  overflow-x: auto;
  min-width: 0;
}

.web-apps-accordion {
  inline-size: 100%;
  block-size: 100%;
}

/* WA: Responsive cards with CSS Grid - cards stretch to fill available width */
.main-objects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(267px, 1fr));
  gap: var(--spacing-gap-l);
  align-items: stretch;
}

.object-card {
  inline-size: 100%; // Adapt to grid column width
  @extend %appCard;
  @extend %appCardInteractive;
  border-width: 1px;
  border-style: solid;

  &.elevation-1 {
    --elevation-border-color: var(
      --color-accent-surface-elevation-1
    ); // Overwrite elevation border color
  }
}

.card-header {
  $commonGap: 8px;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-shrink: 0;

  .left {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: $commonGap;

    .name {
      color: var(--color-text-neutral-default);
      font-weight: var(--font-style-regular); //WA
    }

    .module {
      color: var(--ch-color-text-secondary);
      margin: 0;
    }
  }

  .right {
    .type-container {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: $commonGap;
    }
  }

  .type {
    margin: 0;
    color: var(--color-text-neutral-disabled);
  }
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid var(--color-border-surface-on-elevation-1);
  flex-shrink: 0;

  .description {
    margin: 0;
    line-height: var(--line-height-relaxed);
    color: var(--color-text-neutral-default);
  }

  .angular-icon {
    inline-size: 14px;
    block-size: 14px;
    opacity: 0.8;
  }
}

.no-results,
.no-objects {
  color: var(--color-text-neutral-disabled);
  text-align: center;
  padding: 16px;
}

.recent-objects-grid-container {
  .cell-content {
    display: flex;
    align-items: center;
    gap: var(--spacing-gap-m);
  }
}

.tabular-grid-scroll-container {
  max-block-size: 400px;
  overflow-y: auto;
  overflow-x: hidden;

  // WA: Use thin scrollbar
  scrollbar-width: thin;
}

/* Override global CSS for vertical layout */
:host {
  display: block !important;
}

.header {
  display: block !important;
  inline-size: 100% !important;
  float: none !important;
  clear: both !important;
}

.field {
  display: block !important;
  inline-size: 100% !important;
  float: none !important;
  clear: both !important;
}

.main {
  display: block !important;
  inline-size: 100% !important;
  float: none !important;
  clear: both !important;
}
